import React, {useCallback} from 'react'

import './styles.css';

export const ToggleButton = (props) => {
  const handleChange = useCallback(() => {
    props.setFilter(!props.filter);
    props.setMount(false);
    props.setLoad(true);
    props.setCurrentPage(1);
  }, [props]);

  return (
      <label class="switch">
        <input type="checkbox" onClick={handleChange}/>
        <span  class="slider round"/>
      </label>
  );
}